const e=(e,t)=>e.delete(`/orgs/${t}/purge`);export{e as deleteOrg};
//# sourceMappingURL=delete-org.mjs.map